/** 登入頁（電話 ＋ PIN）—— `decisions/005` */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../lib/api';

export default function Login({ onLoggedIn }: { onLoggedIn: () => void }) {
  const { t } = useTranslation();
  const [phone, setPhone] = useState('');
  const [pin, setPin] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api.login(phone, pin);
      onLoggedIn();
    } catch (ex) {
      setErr(ex instanceof Error && ex.message === 'UNAUTHENTICATED' ? t('auth.failed') : String(ex instanceof Error ? ex.message : ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="page">
      <h1 className="title">{t('app.title')}</h1>
      <form className="card" onSubmit={submit}>
        <h2>{t('auth.heading')}</h2>
        <label className="field">
          <span>{t('auth.phone')}</span>
          <input
            inputMode="tel" autoComplete="tel" value={phone} onChange={(e) => setPhone(e.target.value)}
            placeholder="91234567" required
          />
        </label>
        <label className="field">
          <span>{t('auth.pin')}</span>
          <input
            type="password" autoComplete="current-password" value={pin} onChange={(e) => setPin(e.target.value)}
            required
          />
        </label>
        {err && <p className="err">{err}</p>}
        <button className="cta" type="submit" disabled={busy}>{busy ? t('auth.signing_in') : t('auth.sign_in')}</button>
      </form>
    </main>
  );
}
